import { store } from "../redux/store";
import { SET_SUBSCRIPTION_ACCESS } from "../redux/features/user/userSlice";

const parseJsonResponse = async (response) => {
    const text = await response.text();
    const trimmed = text?.trim() ?? '';

    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
        try {
            return JSON.parse(trimmed);
        } catch (parseError) {
            return {
                success: false,
                error: {
                    error_code: 'INVALID_RESPONSE',
                    error_message: 'The server returned invalid JSON.',
                },
            };
        }
    }

    return {
        success: false,
        error: {
            error_code: 'INVALID_RESPONSE',
            error_message: trimmed
                ? `Server returned ${response.status}: ${trimmed.slice(0, 200)}`
                : `Server returned ${response.status}.`,
        },
    };
};

const handleApi = async (endpoint, method, headers = {}, data = null) => {
    try {
        let { user } = store.getState();
        if (user?.token) {
            headers = { ...headers, token: user?.token };
        }

        let response = await fetch(process.env.REACT_APP_API_URL + endpoint, {
            method: method,
            headers: headers,
            body: data,
        });

        let result = await parseJsonResponse(response);

        if (
            response.status === 403 &&
            result?.error?.error_code === "SUBSCRIPTION_EXPIRED"
        ) {
            store.dispatch(
                SET_SUBSCRIPTION_ACCESS({
                    can_access: false,
                    status: result?.error?.subscription_status ?? "expired",
                    is_subscription_expired: true,
                    days_remaining: 0,
                }),
            );
        }

        return result;
    } catch (e) {
        const message = e?.message || 'Network request failed';
        const isNetworkLike = /failed to fetch|network error|load failed/i.test(message);

        return {
            success: false,
            error: {
                error_code: 'NETWORK_ERROR',
                error_message: isNetworkLike
                    ? 'Unable to reach the server. Please check your connection and try again.'
                    : message,
            },
        };
    }
};

export { handleApi };

export const handleExternalApi = async (url, method, headers, body) => {
    try {
        const response = await fetch(url, {
            method,
            headers,
            body,
        });

        if (!response.ok) {
            const errorBody = await response.text();
            console.error(`API Error: ${response.status} - ${errorBody}`);
            throw new Error(`API request failed with status ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error in handleExternalApi:", error.message);
        throw error;
    }
};
